import { render } from "./StaredContent.vue?vue&type=template&id=5b8a3c87"
import script from "./StaredContent.vue?vue&type=script&lang=js"
export * from "./StaredContent.vue?vue&type=script&lang=js"

import "./StaredContent.vue?vue&type=style&index=0&id=5b8a3c87&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__